export default "https://static-website.miro.com/miro-site-lp-build-assets/_next/static/chunks/fonts/formular-bold-e323387acbb739317827dc0dd1f91f38.eot";